import { render, staticRenderFns } from "./SolanStudentViewAboutT.vue?vue&type=template&id=0c08f8d7&scoped=true&"
import script from "./SolanStudentViewAboutT.vue?vue&type=script&lang=ts&"
export * from "./SolanStudentViewAboutT.vue?vue&type=script&lang=ts&"
import style0 from "./SolanStudentViewAboutT.vue?vue&type=style&index=0&id=0c08f8d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08f8d7",
  null
  
)

export default component.exports